import { render, staticRenderFns } from "./modify_account.vue?vue&type=template&id=686313ba&scoped=true"
import script from "./modify_account.vue?vue&type=script&lang=ts"
export * from "./modify_account.vue?vue&type=script&lang=ts"
import style0 from "./modify_account.vue?vue&type=style&index=0&id=686313ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686313ba",
  null
  
)

export default component.exports